import React from 'react'
import '../../styles/index.scss'
import pickBy from 'lodash/pickBy'

const linkProps = ['activeClassName', 'activeStyle', 'onClick', 'onlyActiveOnIndex']

function removeLinkProps (props) {
  return pickBy(props, (value, key) => {
    return linkProps.indexOf(key) === -1
  })
}

export function isInternalUrl (url) {
  return url.indexOf(window.env.REACT_APP_CORP_URL) >= 0 ||
    (/^https?:\/\/|\/\//.test(url) === false && /^mailto|tel/.test(url) === false)
}

class Link extends React.PureComponent {
  render () {
    const { to, href, children, ismobile = false } = this.props
    let { onClick = () => {} } = this.props
    let formattedUrl
    if (to) formattedUrl = isInternalUrl(to) ? `${window.env.REACT_APP_CORP_URL}${to}` : to
    const url = formattedUrl || href

    if (ismobile) {
      onClick = () => {}
    }

    if (!url) return null
    return <a href={url} onClick={onClick} {...removeLinkProps(this.props)}>{children}</a>
  }
}

export default Link
